import { combineReducers } from "redux";
import { masterReducer } from "./masterReducer";
import { roleReducer } from "./roleReducer";
import { userReducer } from "./userReducer";
import { logHistoryInventoryReducer, logInventoryReducer } from "./Inventory/LogReducer";
import { flitchHistoryInventoryReducer, flitchInventoryReducer } from "./Inventory/flitchReducer";
import loadingReducer from "./loadingReducer";
import { faceInventoryReducer } from "./Inventory/FaceReducer";
import { veneerBlukUploadDataReducer, veneerHistoryInventoryReducer, veneerInventoryReducer } from "./Inventory/VeneerReducer";
import { fleeceInventoryReducer } from "./Inventory/FleeceReducer";
import { coreInventoryReducer } from "./Inventory/CoreReducer";
import { mdfInventoryReducer } from "./Inventory/MdfReducer";
import { plywoodInventoryReducer } from "./Inventory/plywoodReducer";
import { otherGoodsInventoryReducer } from "./Inventory/otherGoodsReducer";
import { issuesForCrosscuttingReducer } from "./Factory/Crosscutting/issuesForCrosscutting";
import { rejectedCrosscuttingReducer } from "./Factory/Crosscutting/rejectedCrosscutting";
import { issuesForFlitchingReducer } from "./Factory/Flitching/issuesForFlitching";
import { crossCutDoneListingReducer } from "./Factory/Crosscutting/crosscutDoneListing/crosscutDoneListing";
import { logExpensesReducer } from "./Master/Expenses/logExpensesReducer";
import { FlitchingDoneReducer } from "./Factory/Flitching/flitchingDone";
import { flitchExpensesReducer } from "./Master/Expenses/flitchExpensesReducer";
import { faceExpensesReducer } from "./Master/Expenses/faceExpensesReducer";
import { coreExpensesReducer } from "./Master/Expenses/coreExpensesReducer";
import { plywoodExpensesReducer } from "./Master/Expenses/plywoodExpensesReducer";
import { veneerExpensesReducer } from "./Master/Expenses/veneerExpensesReducer";
import { mdfExpensesReducer } from "./Master/Expenses/mdfExpensesReducer";
import { fleeceExpensesReducer } from "./Master/Expenses/fleeceExpensesReducer";
import { otherGoodsExpensesReducer } from "./Master/Expenses/otherGoodsExpensesReducer";
import { logApprovalReducer } from "./Approval/logApprovalReducer";
import { flitchApprovalReducer } from "./Approval/flitchApprovalReducer";
import { plywoodApprovalReducer } from "./Approval/plywoodApprovalReducer";
import { veneerApprovalReducer } from "./Approval/veneerApprovalReducer copy";
import { mdfApprovalReducer } from "./Approval/mdfApprovalReducer";
import { faceApprovalReducer } from "./Approval/faceApprovalReducer";
import { coreApprovalReducer } from "./Approval/coreApprovalReducer";
import { fleeceApprovalReducer } from "./Approval/fleeceApprovalReducer";
import { otherGoodsApprovalReducer } from "./Approval/otherGoodsApprovalReducer";
import { crossCutDoneApprovalListingReducer } from "./Approval/crosscuttingDoneApprovalReducer";
import { flitchingDoneApprovalReducer } from "./Approval/flitchingDoneApprovalReducer";
import { barcodeReducer } from "./SeriesProduct/barcodeReducer";
import { furrowReducer } from "./SeriesProduct/furrowReducer";
import { furrowLiteReducer } from "./SeriesProduct/furrowLiteReducer";
import { chromaCollectionReducer } from "./SeriesProduct/chromaCollectionReducer";
import { chromaCompositeReducer } from "./SeriesProduct/chromaCompositeReducer";
import { chromaRibbedReducer } from "./SeriesProduct/chromaRibbedReducer";
import { bunitoReducer } from "./SeriesProduct/bunitoReducer";
import { mattleReducer } from "./SeriesProduct/mattleReducer";
import { canvasReducer } from "./SeriesProduct/canvasReducer";
import { novelReducer } from "./SeriesProduct/novelReducer";
import { marvelReducer } from "./SeriesProduct/marvelReducer";
import { regantoDezinerReducer } from "./SeriesProduct/regantoDezinerReducer";
import { regantoClassicReducer } from "./SeriesProduct/regantoClassicReducer";
import { regantoPremierReducer } from "./SeriesProduct/regantoPremierReducer";
import { accoReducer } from "./SeriesProduct/accoReducer";
import { furrowRegantoReducer } from "./SeriesProduct/furrowRegantoReducer";
import { issuesForPeelingReducer } from "./Factory/Peeling/issuesForPeeling";
import { peelingDoneReducer } from "./Factory/Peeling/peelingDone";
import { peelingHistoryReducer } from "./Factory/Peeling/peelingHistory";
import { peelingWastageReducer } from "./Factory/Peeling/peelingWastage";
import { rfForSlicingReducer } from "./Factory/Peeling/rfForSlicing";
import { reFlitchingDoneReducer } from "./Factory/Peeling/reFlitchingDone";
import { reFlitchingHistoryReducer } from "./Factory/Peeling/reFlitchingHistory";
import { issuesForSlicingReducer } from "./Factory/Slicing/issuesForSlicing";
import { SlicingDoneReducer } from "./Factory/Slicing/slicingDone";
import { SlicingHistoryReducer } from "./Factory/Slicing/slicingHistory";
import { SlicingWastageReducer } from "./Factory/Slicing/slicingWastage";
import { SlicingAvailableReducer } from "./Factory/Slicing/slicingAvailable";
import { issuesForGroupingReducer } from "./Factory/Grouping/issuesForGrouping";
import { groupingDoneReducer } from "./Factory/Grouping/groupingDone";
import { groupingDamageReducer } from "./Factory/Grouping/groupingDamage";
import { issuesForDressingReducer } from "./Factory/Dressing/issuesForDressing";
import { DressingDoneReducer } from "./Factory/Dressing/dressingDone";
import { issuesItemSmokingDyingReducer } from "./Factory/SmokingDying/issuesItem";
import { processDoneSmokingDyingReducer } from "./Factory/SmokingDying/processDone";
import { historySmokingDyingReducer } from "./Factory/SmokingDying/history";
import { DressingMCRawDataReducer } from "./Factory/Dressing/MCRawData";
import { mcMismatchDataReducer } from "./Factory/Dressing/mcMismatchData";
import { dressingHistoryReducer } from "./Factory/Dressing/dressingHistory";
import { rawOrderOrderReducer } from "./Order/RawOrder";
import { decorativeOrderReducer } from "./Order/DecorativeOrder";
import { SeriesProductOrderReducer } from "./Order/SeriesProductOrder";
import { plywoodHistoryReducer } from "./Inventory/plywoodHistoryReducer";
import { mdfHistoryReducer } from "./Inventory/mdfHistoryReducer";
import { faceHistoryReducer } from "./Inventory/faceHistoryReducer";
import { coreHistoryReducer } from "./Inventory/coreHistoryReducer";
import { fleeceHistoryReducer } from "./Inventory/fleeceHistoryReducer";
import { otherGoodsHistoryReducer } from "./Inventory/otherGoodsHistoryReducer";
import { crossCutDoneHistoryListingReducer } from "./Factory/Crosscutting/crosscutDoneHistoryListing/crosscutDoneHistoryListing";
import { flitchingHistoryReducer } from "./Factory/Flitching/flitchingHistory";
import { issuesForTappingReducer } from "./Factory/Tapping/issuesForTapping";
import { groupingHistoryReducer } from "./Factory/Grouping/groupingHistory";
import { tappingDoneReducer } from "./Factory/Tapping/tappingDone";
import { tappingDamageReducer } from "./Factory/Tapping/tappingDamage";
import { tappingDoneHistoryReducer } from "./Factory/Tapping/tappingDoneHistory";
import { issuesForReSizingPlywoodReducer } from "./Factory/ReSizingPlywood/issuesForReSizingPlywood";
import { reSizingPlywoodDoneReducer } from "./Factory/ReSizingPlywood/reSizingPlywoodDone";
import { reSizingPlywoodHistoryReducer } from "./Factory/ReSizingPlywood/reSizingPlywoodHistory";
import { reSizingPlywoodDamageReducer } from "./Factory/ReSizingPlywood/reSizingPlywoodDamage";
import { plywoodProductionDoneReducer } from "./Factory/PlywoodProduction/plywoodProductionDone";
import { plywoodProductionDamageReducer } from "./Factory/PlywoodProduction/plywoodProductionDamage";
import { plywoodProductionHistoryReducer } from "./Factory/PlywoodProduction/plywoodProductionHistory";
import { issuesForCncReducer } from "./Factory/Cnc/issuesForCnc";
import { cncDoneReducer } from "./Factory/Cnc/cncDone";
import { cncDamageReducer } from "./Factory/Cnc/cncDamage";
import { cncHistoryReducer } from "./Factory/Cnc/cncHistory";
import { issuesForPressingReducer } from "./Factory/Pressing/issuesForPressing";
import { pressingDoneReducer } from "./Factory/Pressing/pressingDone";
import { pressingDamageReducer } from "./Factory/Pressing/pressingDamage";
import { issuesForBunitoReducer } from "./Factory/Bunito/issuesForBunito";
import { bunitoDoneReducer } from "./Factory/Bunito/bunitoDone";
import { bunitoDamageReducer } from "./Factory/Bunito/bunitoDamage";
import { bunitoHistoryReducer } from "./Factory/Bunito/bunitoHistory";
import { issuesForColourReducer } from "./Factory/Colour/issuesForColour";
import { colourDoneReducer } from "./Factory/Colour/colourDone";
import { colourDamageReducer } from "./Factory/Colour/colourDamage";
import { colourHistoryReducer } from "./Factory/Colour/colourHistory";
import { issuesForCanvasReducer } from "./Factory/Canvas/issuesForCanvas";
import { canvasHistoryReducer } from "./Factory/Canvas/canvasHistory";
import { canvasDoneReducer } from "./Factory/Canvas/canvasDone";
import { canvasDamageReducer } from "./Factory/Canvas/canvasDamage";
import { issuesForPolishingReducer } from "./Factory/Polishing/issuesForPolishing";
import { polishingDoneReducer } from "./Factory/Polishing/polishingDone";
import { polishingDamageReducer } from "./Factory/Polishing/polishingDamage";
import { polishingHistoryReducer } from "./Factory/Polishing/polishingHistory";
import { issuesForChallanReducer } from "./Challan/issuesForChallan";
import { challanReducer } from "./Challan/challan";
import { sizeDropdownReducer } from "./sizeDropdownReducer";
import { pressingHistoryReducer } from "./Factory/Pressing/pressingHistory";
import { finishedReadyPackingReducer } from "./Packing/finishedReadyPacking";
import { rawReadyPackingReducer } from "./Packing/rawReadyPacking";
import {packingApprovalReducer } from "./Packing/packingApproval"
import { packingDoneReducer } from "./Packing/packingDone";
import { dispatchListReducer } from "./Dispatch/dispatch";
import {dispatchApprovalReducer } from "./Dispatch/dispatchApproval";
import {rawApprovalReducer} from "./Order/RawApprovalOrder";
import {decorativeApprovalOrderReducer} from "./Order/DecorativeApprovalOrder";
import{SeriesProductApprovalOrderReducer} from "./Order/SeriesProductApprovalOrder";

const exportReducers = (history) => {
  return combineReducers({
    //basics
    loadingReducer: loadingReducer,
    userReducer: userReducer,
    roleReducer: roleReducer,
    masterReducer: masterReducer,

    //expenses master
    logExpensesReducer: logExpensesReducer,
    flitchExpensesReducer: flitchExpensesReducer,
    faceExpensesReducer: faceExpensesReducer,
    coreExpensesReducer: coreExpensesReducer,
    plywoodExpensesReducer: plywoodExpensesReducer,
    veneerExpensesReducer: veneerExpensesReducer,
    mdfExpensesReducer: mdfExpensesReducer,
    fleeceExpensesReducer: fleeceExpensesReducer,
    otherGoodsExpensesReducer: otherGoodsExpensesReducer,

    // ======================Inventory=====================
    //Log Inventory
    logInventoryReducer: logInventoryReducer,
    logHistoryInventoryReducer: logHistoryInventoryReducer,
    logApprovalReducer: logApprovalReducer,

    //Flitch Inventory
    flitchInventoryReducer: flitchInventoryReducer,
    flitchHistoryInventoryReducer: flitchHistoryInventoryReducer,
    flitchApprovalReducer: flitchApprovalReducer,

    //veneer Inventory
    veneerInventoryReducer: veneerInventoryReducer,
    veneerBlukUploadDataReducer: veneerBlukUploadDataReducer,
    veneerApprovalReducer: veneerApprovalReducer,
    veneerHistoryInventoryReducer: veneerHistoryInventoryReducer,

    //Face Inventory
    faceInventoryReducer: faceInventoryReducer,
    faceApprovalReducer: faceApprovalReducer,
    faceHistoryReducer: faceHistoryReducer,

    //Core Inventory
    coreInventoryReducer: coreInventoryReducer,
    coreApprovalReducer: coreApprovalReducer,
    coreHistoryReducer: coreHistoryReducer,

    //MDF Inventory
    mdfInventoryReducer: mdfInventoryReducer,
    mdfApprovalReducer: mdfApprovalReducer,
    mdfHistoryReducer: mdfHistoryReducer,

    //Plywood Inventory
    plywoodInventoryReducer: plywoodInventoryReducer,
    plywoodApprovalReducer: plywoodApprovalReducer,
    plywoodHistoryReducer: plywoodHistoryReducer,

    //Fleece Inventory
    fleeceInventoryReducer: fleeceInventoryReducer,
    fleeceApprovalReducer: fleeceApprovalReducer,
    fleeceHistoryReducer: fleeceHistoryReducer,

    //Other Goods Inventory
    otherGoodsInventoryReducer: otherGoodsInventoryReducer,
    otherGoodsApprovalReducer: otherGoodsApprovalReducer,
    otherGoodsHistoryReducer: otherGoodsHistoryReducer,
    // ======================Inventory=====================

    //======================Factory========================
    //crosscuting
    issuesForCrosscuttingReducer: issuesForCrosscuttingReducer,
    rejectedCrosscuttingReducer: rejectedCrosscuttingReducer,
    crossCutDoneListingReducer: crossCutDoneListingReducer,
    crossCutDoneApprovalListingReducer: crossCutDoneApprovalListingReducer,
    crossCutDoneHistoryListingReducer: crossCutDoneHistoryListingReducer,

    //Flitching
    issuesForFlitchingReducer: issuesForFlitchingReducer,
    FlitchingDoneReducer: FlitchingDoneReducer,
    flitchingDoneApprovalReducer: flitchingDoneApprovalReducer,
    flitchingHistoryReducer: flitchingHistoryReducer,

    //Slicing
    issuesForSlicingReducer: issuesForSlicingReducer,
    SlicingDoneReducer: SlicingDoneReducer,
    SlicingHistoryReducer: SlicingHistoryReducer,
    SlicingWastageReducer: SlicingWastageReducer,
    SlicingAvailableReducer: SlicingAvailableReducer,

    //Peeling
    issuesForPeelingReducer: issuesForPeelingReducer,
    peelingDoneReducer: peelingDoneReducer,
    peelingHistoryReducer: peelingHistoryReducer,
    peelingWastageReducer: peelingWastageReducer,
    rfForSlicingReducer: rfForSlicingReducer,
    reFlitchingDoneReducer: reFlitchingDoneReducer,
    reFlitchingHistoryReducer: reFlitchingHistoryReducer,

    // Smoking & Dying
    issuesItemSmokingDyingReducer: issuesItemSmokingDyingReducer,
    processDoneSmokingDyingReducer: processDoneSmokingDyingReducer,
    historySmokingDyingReducer: historySmokingDyingReducer,

    //Dressing
    issuesForDressingReducer: issuesForDressingReducer,
    DressingDoneReducer: DressingDoneReducer,
    DressingMCRawDataReducer: DressingMCRawDataReducer,
    mcMismatchDataReducer: mcMismatchDataReducer,
    dressingHistoryReducer: dressingHistoryReducer,

    //Grouping
    issuesForGroupingReducer: issuesForGroupingReducer,
    groupingDoneReducer: groupingDoneReducer,
    groupingDamageReducer: groupingDamageReducer,
    groupingHistoryReducer: groupingHistoryReducer,

    //Tapping
    issuesForTappingReducer: issuesForTappingReducer,
    tappingDoneReducer: tappingDoneReducer,
    tappingDamageReducer: tappingDamageReducer,
    tappingDoneHistoryReducer: tappingDoneHistoryReducer,

    //Pressing
    issuesForPressingReducer: issuesForPressingReducer,
    pressingDoneReducer: pressingDoneReducer,
    pressingDamageReducer: pressingDamageReducer,
    pressingHistoryReducer: pressingHistoryReducer,

    //Plywood Resizing
    issuesForReSizingPlywoodReducer: issuesForReSizingPlywoodReducer,
    reSizingPlywoodDoneReducer: reSizingPlywoodDoneReducer,
    reSizingPlywoodHistoryReducer: reSizingPlywoodHistoryReducer,
    reSizingPlywoodDamageReducer: reSizingPlywoodDamageReducer,

    //Plywood Production
    plywoodProductionDoneReducer: plywoodProductionDoneReducer,
    plywoodProductionHistoryReducer: plywoodProductionHistoryReducer,
    plywoodProductionDamageReducer: plywoodProductionDamageReducer,

    //CNC
    issuesForCncReducer: issuesForCncReducer,
    cncDoneReducer: cncDoneReducer,
    cncDamageReducer: cncDamageReducer,
    cncHistoryReducer: cncHistoryReducer,

    //Bunito
    issuesForBunitoReducer: issuesForBunitoReducer,
    bunitoDoneReducer: bunitoDoneReducer,
    bunitoDamageReducer: bunitoDamageReducer,
    bunitoHistoryReducer: bunitoHistoryReducer,

    //Color
    issuesForColourReducer: issuesForColourReducer,
    colourDoneReducer: colourDoneReducer,
    colourDamageReducer: colourDamageReducer,
    colourHistoryReducer: colourHistoryReducer,

    //Canvas
    issuesForCanvasReducer: issuesForCanvasReducer,
    canvasHistoryReducer: canvasHistoryReducer,
    canvasDamageReducer: canvasDamageReducer,
    canvasDoneReducer: canvasDoneReducer,

    //Polishing
    issuesForPolishingReducer: issuesForPolishingReducer,
    polishingDoneReducer: polishingDoneReducer,
    polishingDamageReducer: polishingDamageReducer,
    polishingHistoryReducer: polishingHistoryReducer,

    //======================Factory========================

    // Series Product
    barcodeReducer: barcodeReducer,
    chromaCollectionReducer: chromaCollectionReducer,
    furrowReducer: furrowReducer,
    chromaCompositeReducer: chromaCompositeReducer,
    chromaRibbedReducer: chromaRibbedReducer,
    bunitoReducer: bunitoReducer,
    mattleReducer: mattleReducer,
    canvasReducer: canvasReducer,
    novelReducer: novelReducer,
    marvelReducer: marvelReducer,
    regantoDezinerReducer: regantoDezinerReducer,
    regantoClassicReducer: regantoClassicReducer,
    regantoPremierReducer: regantoPremierReducer,
    accoReducer: accoReducer,
    furrowLiteReducer: furrowLiteReducer,
    furrowRegantoReducer: furrowRegantoReducer,

    //=======================Order=============
    rawOrderOrderReducer: rawOrderOrderReducer,
    decorativeOrderReducer: decorativeOrderReducer,
    SeriesProductOrderReducer: SeriesProductOrderReducer,
    rawApprovalReducer: rawApprovalReducer,
    decorativeApprovalOrderReducer: decorativeApprovalOrderReducer,
    SeriesProductApprovalOrderReducer: SeriesProductApprovalOrderReducer,

    //======================Challan==================
    issuesForChallanReducer: issuesForChallanReducer,
    challanReducer: challanReducer,
    sizeDropdownReducer: sizeDropdownReducer,

    //dispatch
    dispatchListReducer: dispatchListReducer,
    finishedReadyPackingReducer: finishedReadyPackingReducer,
    rawReadyPackingReducer: rawReadyPackingReducer,
    packingDoneReducer: packingDoneReducer,
    packingApprovalReducer: packingApprovalReducer,
    dispatchApprovalReducer: dispatchApprovalReducer,
  });
};

export default exportReducers;
